import React from "react"
import { makeStyles } from "@material-ui/core"
import LeadForm from "../forms/LeadForm"

const useStyles = makeStyles(theme => ({
  root: {
    background: theme.palette.primary.light,
    padding: theme.spacing(4),
    minHeight: 250,
    display: "flex",
    justifyContent: "center",
  },
}))

const OfferFooter = () => {
  const classes = useStyles()
  return (
    <div className={classes.root}>
      <div>
        <LeadForm />
      </div>
    </div>
  )
}
export default OfferFooter
